module.exports = __webpack_public_path__ + "videos/33.5453fd4.mp4";